import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/** Download action published by the Swagger view and rendered in the breadcrumbs bar. */
export interface SpecDownloadAction {
  /** e.g. "ApiMetadata · v1.0 · TCTSI" */
  label: string;
  /** false for outdated Swagger 2.0 definitions */
  downloadable: boolean;
  /** Full explanation (tooltip) shown when not downloadable */
  hint: string | null;
  /** Short inline label shown when not downloadable */
  hintShort: string | null;
  /** Produces the region-configured spec file; null when nothing can be downloaded. */
  getFile: () => Observable<File> | null;
}

/**
 * Bridges the Swagger view (inside the router outlet) and the breadcrumbs bar (in the app shell):
 * the view publishes what can be downloaded, the breadcrumbs render the button.
 */
@Injectable({ providedIn: 'root' })
export class SpecDownloadService {
  private readonly action$ = new BehaviorSubject<SpecDownloadAction | null>(null);
  readonly current$: Observable<SpecDownloadAction | null> = this.action$.asObservable();

  set(action: SpecDownloadAction): void {
    this.action$.next(action);
  }

  clear(): void {
    this.action$.next(null);
  }
}
